const phoneType = {
  landLine: 'Talian Tanah',
  mobile: 'Mudah alih',
  fax: 'Faks',
};

export default phoneType;
